// extracted by mini-css-extract-plugin
export default {"search":"index_search_uwdHT","input":"index_input_zqGU3","searchBut":"index_searchBut_NzJn1"};